export type BannerLinkType = "category" | "brand" | "product" | "url" | "none";

/** Resolves a banner link type + value into an href, or null when there is no link. */
export function bannerHref(
  linkType: string | null | undefined,
  linkValue: string | null | undefined,
): string | null {
  if (!linkType || linkType === "none" || !linkValue) return null;
  switch (linkType) {
    case "category":
      return `/category/${linkValue}`;
    case "brand":
      return `/brand/${linkValue}`;
    case "product":
      return `/product/${linkValue}`;
    case "url":
      return linkValue;
    default:
      return null;
  }
}
